<template>
    <div
        class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2 lg:ppv2-grid-cols-4 ppv2-mb-6"
        :style="{ gap: normalizeSize(16, true) }"
        style="padding-left: 1%"
    >
        <!-- Products Card -->
        <div
            @click="$emit('click', 'products')"
            class="ppv2-rounded-xl ppv2-p-4 ppv2-flex ppv2-items-center ppv2-shadow-sm ppv2-border ppv2-border-white ppv2-border-opacity-10 ppv2-cursor-pointer hover:ppv2-bg-white hover:ppv2-bg-opacity-5 ppv2-transition-all"
            :style="{ gap: normalizeSize(16, true) }"
        >
            <div
                class="ppv2-p-3 ppv2-bg-white ppv2-bg-opacity-10 ppv2-rounded-lg ppv2-border ppv2-border-white ppv2-border-opacity-20"
            >
                <Tag class="ppv2-w-6 ppv2-h-6 ppv2-text-white" />
            </div>
            <div>
                <div class="ppv2-text-2xl poppinsBold ppv2-text-white">{{ stats.products }}</div>
                <div class="ppv2-text-sm ppv2-text-white ppv2-text-opacity-70">{{ $t('products.stats.products') }}</div>
            </div>
        </div>

        <!-- Categories Card -->
        <div
            @click="$emit('click', 'categories')"
            class="ppv2-rounded-xl ppv2-p-4 ppv2-flex ppv2-items-center ppv2-shadow-sm ppv2-border ppv2-border-white ppv2-border-opacity-10 ppv2-cursor-pointer hover:ppv2-bg-white hover:ppv2-bg-opacity-5 ppv2-transition-all"
            :style="{ gap: normalizeSize(16, true) }"
        >
            <div
                class="ppv2-p-3 ppv2-bg-white ppv2-bg-opacity-10 ppv2-rounded-lg ppv2-border ppv2-border-white ppv2-border-opacity-20"
            >
                <FolderTree class="ppv2-w-6 ppv2-h-6 ppv2-text-white" />
            </div>
            <div>
                <div class="ppv2-text-2xl poppinsBold ppv2-text-white">{{ stats.categories }}</div>
                <div class="ppv2-text-sm ppv2-text-white ppv2-text-opacity-70">{{ $t('products.stats.categories') }}</div>
            </div>
        </div>

        <!-- Suppliers Card -->
        <div
            @click="$emit('click', 'suppliers')"
            class="ppv2-rounded-xl ppv2-p-4 ppv2-flex ppv2-items-center ppv2-shadow-sm ppv2-border ppv2-border-white ppv2-border-opacity-10 ppv2-cursor-pointer hover:ppv2-bg-white hover:ppv2-bg-opacity-5 ppv2-transition-all"
            :style="{ gap: normalizeSize(16, true) }"
        >
            <div
                class="ppv2-p-3 ppv2-bg-white ppv2-bg-opacity-10 ppv2-rounded-lg ppv2-border ppv2-border-white ppv2-border-opacity-20"
            >
                <Package class="ppv2-w-6 ppv2-h-6 ppv2-text-white" />
            </div>
            <div>
                <div class="ppv2-text-2xl poppinsBold ppv2-text-white">{{ stats.suppliers }}</div>
                <div class="ppv2-text-sm ppv2-text-white ppv2-text-opacity-70">{{ $t('products.stats.suppliers') }}</div>
            </div>
        </div>

        <!-- Brands Card -->
        <div
            @click="$emit('click', 'brands')"
            class="ppv2-rounded-xl ppv2-p-4 ppv2-flex ppv2-items-center ppv2-shadow-sm ppv2-border ppv2-border-white ppv2-border-opacity-10 ppv2-cursor-pointer hover:ppv2-bg-white hover:ppv2-bg-opacity-5 ppv2-transition-all"
            :style="{ gap: normalizeSize(16, true) }"
        >
            <div
                class="ppv2-p-3 ppv2-bg-white ppv2-bg-opacity-10 ppv2-rounded-lg ppv2-border ppv2-border-white ppv2-border-opacity-20"
            >
                <List class="ppv2-w-6 ppv2-h-6 ppv2-text-white" />
            </div>
            <div>
                <div class="ppv2-text-2xl poppinsBold ppv2-text-white">{{ stats.brands }}</div>
                <div class="ppv2-text-sm ppv2-text-white ppv2-text-opacity-70">{{ $t('products.stats.brands') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import { Tag, FolderTree, Package, List } from 'lucide-vue'

export default {
    name: 'ProductStatsCards',
    components: {
        Tag,
        FolderTree,
        Package,
        List,
    },
    data() {
        return {
            stats: {
                products: 0,
                categories: 0,
                suppliers: 0,
                brands: 0,
            },
        }
    },
    async mounted() {
        await this.fetchStats()
    },
    methods: {
        normalizeSize,
        async fetchStats() {
            try {
                const response = await axios.get('/api/v3/product/stats')
                this.stats = response.data
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
    },
}
</script>
